import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { routerActions } from 'connected-react-router';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Button } from 'semantic-ui-react';
import RefreshButton from '../../components/RefreshButton';
import * as Facility from '../../store/Facility';

class FacilityList extends Component {
    constructor(props) {
        super(props);
        
        this.onAddClick = this.onAddClick.bind(this);
        this.onEditClick = this.onEditClick.bind(this);
    }

    onAddClick(e) {
        const {actions} = this.props;
        actions.push('/admin/facility/add');
    }

    onEditClick(e, {data}){
        const {actions} = this.props;
        actions.push(`/admin/facility/${data}`);
    }
    
    render() {
        const {facility, actions} = this.props;
        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2} textAlign="center">Facilities</Table.HeaderCell>
                            <Table.HeaderCell><RefreshButton floated="right" action={async () => await actions.getFacilities()} /></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {Object.values(facility.facilities).map((f, index) => (
                            <Table.Row>
                                <Table.Cell width="1"><Button content="edit" data={f.id} onClick={this.onEditClick} /></Table.Cell>
                                <Table.Cell>{f.name}</Table.Cell>
                                <Table.Cell>{`${f.address}, ${f.city}, ${f.state} ${f.zip}`}</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan={3}>
                                <Button content="Add" onClick={this.onAddClick} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        );
    }
}

FacilityList.propTypes = {
    facility: PropTypes.object,
    actions: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => {
    return {
        facility: Facility.selector(state)
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(Facility.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilityList));